<template>
  <div>
    <loader v-model="status.loading"></loader>
    <arksnackbar v-model="status"></arksnackbar>

    <customdialog
      v-model="dialog"
      :maxWidth="options.width"
      :title="title"
      :cardtextstyle="'height: 250px;'"
    >
      <br />
      <v-flex>
        <span class="body-1 font-weight-medium">ETN :</span>
        <span class="body-1 font-weight-regular"> {{ FaturaGuid }} </span>
      </v-flex>
      <br />

      <v-form
        ref="formaktarim"
        id="formaktarim"
        method="post"
        enctype="multipart/form-data"
        lazy-validation
      >
        <input
          class="custom-file-input"
          type="file"
          :label="$t('Select-File')"
          id="files"
          ref="files"
          @change="onFileChange"
          accept=".jpeg, .jpg, .csv, .doc, .docx, .pdf, .rar, .xls, .xlsx, .zip"
          multiple
        />
      </v-form>

      <br />

      <v-flex>
        <span class="body-1 font-weight-medium">{{ sonuc }}</span>
      </v-flex>

      <template slot="btn">
        <v-btn color="primary" flat @click.native="yes()">{{
          btnYesCaption
        }}</v-btn>
      </template>
    </customdialog>
  </div>
</template>

<script>
import customdialog from "@/components/app/coper/comp/customdialog.vue";
import tool from "@/components/app/coper/tools";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import loader from "@/components/app/coper/comp/loader.vue";

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      status: tool.NewSatatus(),
      sendControl: true,
      title: null,

      btnYesCaption: this.$t('OK'),
      faturatur: null,
      faturaid: null,
      FaturaGuid: null,
      sonuc: "",

      options: {
        color: "primary",
        width: 450,
      },
      files: [],
    };
  },
  components: {
    customdialog,
    arksnackbar,
    loader,
  },
  methods: {
    open(faturatur, faturaid, FaturaGuid) {
      this.btnYesCaption = "Gönder";
      this.title = "E Fatura Tekrar Dosya Ekle";
      this.files = [];
      this.faturatur = faturatur;
      this.faturaid = faturaid;
      this.FaturaGuid = FaturaGuid;

      this.dialog = true;

      this.sonuc = "";

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onFileChange(e) {
      this.sendControl = true;

      if (e.target.files.length > 10) {
        this.sonuc = this.$t('can-send-files');
        this.sendControl = false;
        this.files = [];
        return false;
      } else {
        for (let index = 0; index < e.target.files.length; index++) {
          const element = e.target.files[index];
          if (element.size > 3000000) {
            this.sonuc = this.$t('File-size-cannot-exceed-mb');
            this.sendControl = false;
            this.files = [];
            return false;
          }
        }
      }

      if (this.sendControl) {
        this.files = e.target.files;
        this.sonuc = "";
      }
    },

    yes() {
      if (this.files.length > 0) {
        var prm = {
           id: this.faturaid,
           guid: this.FaturaGuid,
        };
 
        this.status.loading = true;

        tool
          .api_file_post2(
            this,
            "EFatura/TekrarGonderDosyaEkle",
            this.files,
            prm
          )
          .then(
            (response) => {
              if (response.body.OperationCompleted == true) {
                this.status.text = this.$t('invoice-sent-approval');
                this.status.show = true;
              } else {
                this.status.text = "Hata: " + response.body.message;
                this.status.show = true;
              }
              this.sonuc = response.body.message;
              this.status.loading = false;
              this.dialog = false;
            },
            (response) => {
              this.sonuc = response.body.ExceptionMessage;

              this.status = tool.responseToStatus(response);
            }
          );
      } else {
        this.sonuc = this.sonuc + this.$t('Applicable-file-not-found');
      }
    },

    onayaGonder() {
      this.islemstatus = true;
      var prm = {
        faturaTip: this.faturatur,
        faturaList: [],
      };
      prm.faturaList.push({
        id: this.faturaid,
        guid: this.FaturaInput.FaturaGuid,
      });

      tool.api_post(this, "EFatura/EFaturaGonder", prm).then(
        (response) => {
          if (response.body[0].OperationCompleted == true) {
            //this.islemstatus = false
            //this.text1 = 'Faturanız onaya gönderildi.' //response.body[0].message
            //this.snackbar = true
          } else {
            //this.islemstatus = false
            //this.text1 = 'Hata: ' + response.body[0].message
            //this.snackbar = true
          }
          this.resolve(true);
          this.dialog = false;
        },
        (response) => {
          //this.status = tool.responseToStatus(response);
          //this.islemstatus = false
          //this.text1 = response.body.InnerException.ExceptionMessage
          //this.snackbar = true
          this.status = tool.responseToStatus(response);
        }
      );
    },

    cancel() {
      this.resolve(null);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  cursor: pointer !important;
  font: 300 14px sans-serif;
  color: #9e9e9e;
}
input[type="file"]::-webkit-file-upload-button {
  font: 300 14px sans-serif;
  background: #009688;
  border: 0;
  padding: 12px 25px;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
}

input[type="file"]::-ms-browse {
  font: 300 14px "Roboto", sans-serif;
  background: #009688;
  border: 0;
  padding: 12px 25px;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
}
</style>